<template>
  <div class="bigEvent race" :class="{floating: !inplace}"
       :style="inplace ? {} : {left: race.position.left + 'px', top: race.position.top + 'px'}">
    <div class="event-header">
      <span class="event-date">{{ race.datetime.date() }} <template v-if="$mq == 'sm'">({{ race.datetime.format('ddd')}})</template></span>
      <span class="event-name">ZAWODY</span>
      <span class="event-actions">
        <v-icon dark class="click-effect" v-if="isActiveRunnerTrainer || isActiveRunner" v-tooltip="'Edytuj'" @click.stop="$emit('edit-race')">edit</v-icon>
        <v-icon dark class="click-effect" v-if="isActiveRunnerTrainer || isActiveRunner" v-tooltip="'Usuń'" @click.stop="$emit('remove-race')">delete</v-icon>
        <v-icon dark class="click-effect ml-2" v-if="!inplace" v-tooltip="'Zamknij'" @click.stop="$emit('close')">close</v-icon>
      </span>
    </div>
    <div class="event-content">
      <div class="event-content__header">
        Zaplanowane zawody
        <v-icon class="click-effect" v-if="isActiveRunnerTrainer || isActiveRunner" v-tooltip="'Edytuj zawody'" @click.stop="$emit('edit-race')">edit</v-icon>
      </div>
      <ul>
        <li v-if="measureable">
          <TextField label="Dystans">
            <i slot="prepend" v-tooltip="'Dystans'" class="fi flaticon-road-1"></i>
            {{race.race_type_name}}: {{race.distance_string_name }}
          </TextField>
        </li>
        <li v-if="!measureable">
          <TextField label="Dystans">
            <i slot="prepend" v-tooltip="'Dystans'" class="fi flaticon-road-1"></i>
            {{race.race_type_name}}: {{race.distance_km }} km
          </TextField>
        </li>
        <li v-if="race.race_type === 'street'">
          <TextField label="Atest">
            <v-icon slot="prepend" v-tooltip="'Atest'">spellcheck</v-icon>
            {{race.certified ? 'Tak': 'Nie' }}
          </TextField>
        </li>
        <li>
          <TextField label="Priorytet">
            <i slot="prepend" v-tooltip="'Priorytet'" class="text-icon">P</i>
            {{race.priority }}
          </TextField>
        </li>
        <li>
          <TextField label="Nazwa">
            <i slot="prepend" v-tooltip="'Nazwa'" class="text-icon">N</i>
            {{race.name }}
          </TextField>
        </li>
        <li>
          <TextField label="Miasto">
            <v-icon slot="prepend" v-tooltip="'Miasto'">location_city</v-icon>
            {{race.city }}
          </TextField>
        </li>
      </ul>
      <div v-if="race.trainer_remarks">
          <TextField label="Informacje od trenera">
            <v-icon slot="prepend" v-tooltip="'Informacje od trenera'">info</v-icon>
            {{race.trainer_remarks}}
          </TextField>
      </div>
      <div class="event-results">
        <div class="event-results__header">
          Rezultat zawodnika
          <span class="ml-auto" v-if="!edit && (isActiveRunnerTrainer || isActiveRunner)" v-tooltip="race.time ? 'Edytuj wynik' : 'Dodaj wynik'" @click.stop="edit=true">
            <v-icon class="click-effect" v-if="!race.time">add_circle_outline</v-icon>
            <v-icon class="click-effect" v-if="race.time">edit</v-icon>
          </span>
        </div>
        <ul v-if="!edit">
          <li v-if="race.time">
            <TextField label="Czas">
              <i slot="prepend" v-tooltip="'Czas'" class="fi flaticon-minutes "></i>
              {{race.time}}
            </TextField>
          </li>
          <li v-if="race.place">
            <TextField label="Miejsce">
              <i slot="prepend" v-tooltip="'Miejsce'" class="text-icon">M</i>
              {{race.place}}
            </TextField>
          </li>
          <li v-if="race.post_remarks">
              <TextField label="Informacje od zawodnika" pre>
                <v-icon slot="prepend" v-tooltip="'Informacje od zawodnika'">info</v-icon>{{race.post_remarks}}
              </TextField>
          </li>
        </ul>
        <v-form v-if="edit && (isActiveRunnerTrainer || isActiveRunner)" inline @submit.prevent="saveRace" novalidate>
          <v-text-field
              v-model="raceForm.time"
              label="Czas"
              :error="hasErrors('time')"
              :error-messages="getErrors('time')"
              placeholder="H:M:S"
          >
            <i slot="prepend" v-tooltip="'Czas'" class="fi flaticon-minutes"></i>
          </v-text-field>
          <v-text-field
              v-model="raceForm.place"
              label="Miejsce"
              :error="hasErrors('place')"
              :error-messages="getErrors('place')"
          >
            <i slot="prepend" v-tooltip="'Miejsce'" class="text-icon">M</i>
          </v-text-field>
          <v-textarea
              v-model="raceForm.post_remarks"
              label="Informacje dodatkowe"
              :error="hasErrors('post_remarks')"
              :error-messages="getErrors('post_remarks')"
              auto-grow
              box
          >
            <v-icon slot="prepend" v-tooltip="'Informacje dodatkowe'">info</v-icon>
          </v-textarea>
          <div class="save-button-container">
            <v-btn small dark class="very-small" color="tertiary" type="submit">
              zapisz
              <v-icon right small >save</v-icon>
            </v-btn>
          </div>
        </v-form>
      </div>
    </div>
    <div class="event-footer">
    </div>
  </div>
</template>

<script>
import {doneRace} from './api'
import { mapGetters } from 'vuex'
import iziToast from 'izitoast'
import TextField from '@/utils/TextField'

export default {
  components: {TextField},
  props: {
    race: {
      type: Object,
      required: true
    },
    inplace: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      raceForm: {
        id: this.race.id,
        time: this.race.time || undefined,
        place: this.race.place || undefined,
        post_remarks: this.race.post_remarks || undefined
      },
      errors: {},
      edit: false
    }
  },
  computed: {
    ...mapGetters(['runner', 'isActiveRunnerTrainer', 'isActiveRunner']),
    measureable () {
      return this.race.distance_string !== 'other' && this.race.distance_string !== 'ultra'
    }
  },
  methods: {
    saveRace () {
      let promise = doneRace(this.runner, this.raceForm).then((data) => {
        this.$emit('ended-race', data, this.race)
        this.edit = false
        iziToast.show({
          message: 'Wynik został zmieniony',
          color: 'green'
        })
        return data
      })
      promise.catch((data) => {
        if (data.response.status === 400) {
          this.errors = data.response.data
        }
      })
    },
    getErrors (name) {
      return this.errors[name] || []
    },
    hasErrors (name) {
      return this.errors[name] !== undefined && this.errors[name].length > 0
    },
    resetErrors () {
      this.errors = {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plan/RaceBig.vue